import React, {Component} from 'react';
import PropTypes from 'prop-types';

import * as d3 from 'd3';
import _ from 'lodash';

import {formatKmbt} from '../utils/d3-mixins'

import './ScatterPlot.css';

class ScatterPlotGrid extends Component {

  shouldComponentUpdate(nextProps) {
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;
    const dataDifferent = nextProps.data !== this.props.data;
    const dimXDiff = nextProps.dimX !== this.props.dimX;
    const dimYDiff = nextProps.dimY !== this.props.dimY;

    return widthDifferent || heightDifferent || dataDifferent || dimXDiff || dimYDiff;
  }

  componentDidUpdate() {
    setTimeout(this.renderD3.bind(this), 100);
  }

  // returns slope, intercept and r-square of the line
  // leastSquares(xSeries, ySeries) {
  //   const reduceSumFunc = (prev, cur) => prev + cur;
  //
  //   const xBar = xSeries.reduce(reduceSumFunc) * 1.0 / xSeries.length;
  //   const yBar = ySeries.reduce(reduceSumFunc) * 1.0 / ySeries.length;
  //
  //   const ssXX = xSeries.map(d => Math.pow(d - xBar, 2)).reduce(reduceSumFunc);
  //   const ssYY = ySeries.map(d => Math.pow(d - yBar, 2)).reduce(reduceSumFunc);
  //   const ssXY = xSeries.map((d, i) => (d - xBar) * (ySeries[i] - yBar)).reduce(reduceSumFunc);
  //
  //   const slope = ssXY / ssXX;
  //   const intercept = yBar - (xBar * slope);
  //   const rSquare = Math.pow(ssXY, 2) / (ssXX * ssYY);
  //
  //   return [slope, intercept, rSquare];
  // }
  //
  // calculateLineData(leastSquares,xRange,iterations){
  //   var returnData = [];
  //   for(var i=0; i<iterations; i++){
  //     var randomX = this.randomFloatBetween(xRange[0],xRange[1]);
  //     returnData.push({
  //       xVal:randomX,
  //       yVal: (randomX*leastSquares[0])+leastSquares[1]
  //     });
  //   }
  //   return returnData;
  // }

  renderD3() {
    const width = this.props.width - 56;
    const height = this.props.height - 56;
    const props = this.props;

    const bivarColors = [
      {c: '#e8e8e8', y: 0, x: 0},
      {c: '#e4acac', y: 0, x: 1},
      {c: '#c85a5a', y: 0, x: 2},
      {c: '#b0d5df', y: 1, x: 0},
      {c: '#ad9ea5', y: 1, x: 1},
      {c: '#985356', y: 1, x: 2},
      {c: '#64acbe', y: 2, x: 0},
      {c: '#627f8c', y: 2, x: 1},
      {c: '#5d434c', y: 2, x: 2}
    ];

    if (!props.data.length) {
      return;
    }

    const valueId = row => _.get(row, props.dimId);
    const valueX = row => _.get(row, props.dimX, 0);
    const valueY = row => _.get(row, props.dimY, 0);

    const valuesX = _.map(props.data, valueX);
    const valuesY = _.map(props.data, valueY);

    const extentX = d3.extent(valuesX);
    const extentY = d3.extent(valuesY);

    const quantilesX = d3.scaleQuantile().domain(valuesX).range([0, 1, 2]);
    const quantilesY = d3.scaleQuantile().domain(valuesY).range([0, 1, 2]);

    const ticksX = quantilesX.quantiles().slice();
    ticksX.unshift(extentX[0]);
    ticksX.push(extentX[1]);

    const x = d3.scaleLinear().domain(extentX).range([0, width]);
    const axisX = d3.axisBottom(x).tickValues(ticksX).tickSize(4).tickFormat(formatKmbt);

    const ticksY = quantilesY.quantiles().slice();
    ticksY.unshift(extentY[0]);
    ticksY.push(extentY[1]);

    const y = d3.scaleLinear().domain(extentY).range([height, 0]);
    const axisY = d3.axisLeft(y).tickValues(ticksY).tickSize(4).tickFormat(formatKmbt);

    // Add the X Axis
    d3.select(this.refs.xAxis)
      .transition()
      .call(axisX);

    // Add the Y Axis
    d3.select(this.refs.yAxis)
      .transition()
      .call(axisY);

    d3.select(this.refs.xTitle)
      .text(props.titleX || '');

    d3.select(this.refs.yTitle)
      .text(props.titleY || '');

    // Add colored bg rects
    const rects = d3.select(this.refs.colors)
      .selectAll("rect")
      .data(bivarColors);

    rects.enter().append("rect").each(setRect);
    rects.each(setRect);
    rects.exit().remove();

    function setRect() {
      d3.select(this)
        .style("fill", function (d) {
          return d.c;
        })
        .transition()
        .attr("width", function (d) {
          return x(ticksX[d.x + 1]) - x(ticksX[d.x]) + 1;
        })
        .attr("height", function (d) {
          return y(ticksY[d.y]) - y(ticksY[d.y + 1]) + 1;
        })
        .attr("y", function (d) {
          return y(ticksY[d.y + 1]);
        })
        .attr("x", function (d) {
          return x(ticksX[d.x]);
        });
    }

    // Add points
    const points = d3.select(this.refs.points)
      .selectAll("circle")
      .data(props.data);

    points.enter().append("circle").each(setPoint);
    points.each(setPoint);
    points.exit().remove();

    function setPoint() {
      d3.select(this)
        .attr("r", 3)
        .attr('class', 'hover_out')
        .attr("id", d => "FIPS_" + valueId(d))
        .on("mouseover", d => {
          const coords = [x(valueX(d)), y(valueY(d))];
          if (props.onHoverOver) {
            props.onHoverOver(valueId(d), {coords, props, data: d})
          }
        })
        .on("mouseout", d => {
          if (props.onHoverOut) {
            props.onHoverOut(valueId(d))
          }
        })
        .transition()
        .attr("cy", d => y(valueY(d)))
        .attr("cx", d => x(valueX(d)));
    }
  }

  render() {
    return (
      <svg className="ScatterPlotGrid" width={this.props.width} height={this.props.height}>
        <g transform={"translate(28,28)"} ref="svg">
          <g ref="colors"></g>

          <g className="axis">
            <g ref="xAxis" transform={"translate(0," + (this.props.height - 55) + ")"}></g>
            <g ref="yAxis" className="axis"></g>
            <text ref="xTitle" textAnchor="middle" x={this.props.width / 2 - 28} y={-10}></text>
            <text ref="yTitle" textAnchor="middle"
                  transform={"translate(" + (this.props.width - 46) + "," + (this.props.height / 2 - 28) + ") rotate(90)"}></text>
          </g>

          <g ref="points"></g>
        </g>
      </svg>
    );
  }
}

ScatterPlotGrid.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  titleX: PropTypes.string,
  titleY: PropTypes.string,
  dimId: PropTypes.string,
  dimX: PropTypes.string,
  dimY: PropTypes.string,
  data: PropTypes.array,
  onHoverOver: PropTypes.func,
  onHoverOut: PropTypes.func,
};


export default ScatterPlotGrid



// WEBPACK FOOTER //
// ./src/charts/ScatterPlot/ScatterPlotGrid.js